import fetch from './index'

export function getChannelsList(params): any {
  return fetch.get('/sale/channels/page/list', { params })
}

export function getChannelsListType2(params: any): any {
  return fetch.get('/sale/channels/page/list', { params: { ...params, type: 2 } })
}

export function delChannel(id) {
  return fetch.delete(`/sale/channels/${id}`)
}

export function addChannel(params) {
  return fetch.post('/sale/channels', params)
}

export function editChannel(params) {
  return fetch.put('/sale/channels', params)
}

export function getAllChannelsList(params): any {
  return fetch.get('/sale/channels/list', { params })
}

// 工作台只列试点绑定渠道：绑定由网关按登录租户返回，前端不写死渠道号；写入仍由服务端逐次核验。
// openspec: add-lifecycle-workbench-pilot
export function getWorkbenchPilotChannels(): Promise<{ channelId: number; siteKey: string }[]> {
  return fetch.get<unknown, { channelId: number; siteKey: string }[]>('/eps/workbench/pilot/channels')
}

export async function getWorkbenchPilotChannelList(): Promise<any[]> {
  const [rows, bindings] = await Promise.all([getAllChannelsList({}), getWorkbenchPilotChannels()])
  if (!Array.isArray(rows) || !Array.isArray(bindings)
    || bindings.some(binding => !Number.isSafeInteger(binding?.channelId))) throw Error('incomplete channels')
  const bound = new Set(bindings.map(binding => binding.channelId))
  return rows.filter(row => bound.has(row.id))
}
// 渠道排序
export function putChannelSort(params): any {
  return fetch.post('/sale/channels/sort', params)
}